var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import VueDialog from "../../../interface/IVueDialog";
var ExportResult = (function (_super) {
    __extends(ExportResult, _super);
    function ExportResult() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.exportDetail = {};
        _this.listData = [];
        _this.listDataMergeColumn = [];
        _this.checkedData = [];
        _this.remember = true;
        _this.formData = {
            mergeColumn: "merge_column_no"
        };
        _this.mergeColumnList = [
            {
                id: "merge_column_yes",
                name: '合并列显示'
            },
            {
                id: "merge_column_no",
                name: '分列显示'
            }
        ];
        _this.instructionsVisible = false;
        return _this;
    }
    ExportResult.prototype.created = function () {
        var _this = this;
        this.exportDetail = this.exportDetail;
        var data = this.exportDetail.table_header_column || [];
        data.forEach(function (group, gIndex) {
            if (group.type == 4) {
                group.data.forEach(function (item) {
                    if (item.is_hidden == 0) {
                        _this.formData.mergeColumn = item.key;
                    }
                });
                _this.listDataMergeColumn.push(group);
            }
            else {
                _this.listData.push(group);
            }
        });
        this.listData.forEach(function (group, gIndex) {
            _this.checkedData[gIndex] = [];
            group.data.forEach(function (item) {
                if (item.is_hidden == 0) {
                    _this.checkedData[gIndex].push(item.name);
                }
            });
        });
    };
    ExportResult.prototype.exportData = function () {
        var _this = this;
        if (this.checkedData.some(function (item) { return item.length === 0; })) {
            return this.$message.warning("请选择要导出的内容项");
        }
        this.listData.map(function (group, gIndex) {
            group.data.forEach(function (item) {
                item.is_hidden = _this.checkedData[gIndex].indexOf(item.name) >= 0 ? 0 : 1;
            });
        });
        this.listDataMergeColumn[0].data.forEach(function (item) {
            item.is_hidden = (item.key == _this.formData.mergeColumn) ? 0 : 1;
        });
        this.exportDetail.table_header_column = this.listData.concat(this.listDataMergeColumn);
        this.$emit("export:ok", JSON.stringify({
            exportDetail: this.exportDetail,
            remember: this.remember
        }));
        this.close();
    };
    ExportResult.prototype.closeInstructions = function () {
        this.instructionsVisible = false;
    };
    ExportResult.prototype.close = function () {
        this.$closeDialog();
    };
    ExportResult.prototype.handleCheckedChange = function (value) {
    };
    ExportResult = __decorate([
        Component
    ], ExportResult);
    return ExportResult;
}(VueDialog));
export default ExportResult;
